import styled from '@emotion/styled';
import IconButton from 'common/components/IconButton';
import SearchInput from 'common/components/SearchInput';
import useSearch from 'common/hooks/useSearch';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import React, { useState } from 'react';
import EventImage1 from '../../images/event1.jpg';
import EventImage2 from '../../images/event2.jpg';
import EventImage3 from '../../images/event3.jpg';
import EventImage4 from '../../images/event4.png';
import EventImage5 from '../../images/event5.jpg';
import { ReactComponent as SmallKimsLogo } from '../../icons/small_kims.svg';
import { useTheme } from '@mui/material';
import { ReactComponent as LocationIcon } from 'common/icons/location.svg';

const SearchWrapper = styled.div`
    display:flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
`;

type EventProps = {
  title: string;
  date: string;
  location: string;
  image: string;
};

const EventWrapper = styled.div`
    display:flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    gap: 4px;
`;

const EventList: EventProps[] = [
  {
    title: 'День без поліетилену в Україні',
    date: '3 липня 2023',
    location: 'Одесса, вул. Люстдорфська дорога, 5',
    image: EventImage1,
  },
  {
    title: 'Кімсні Схили, перший в історії Одеси масовий плоггінг!',
    date: '19 травня 2023',
    location: 'Одесса, Траса здоров\'я',
    image: EventImage2,
  },
  {
    title: 'Майстер-класи з догляду за одягом',
    date: '12 лютого 2023',
    location: 'Одесса, вул. Люстдорфська дорога, 5',
    image: EventImage3,
  },
  {
    title: 'Відкриття нового філіалу',
    date: '10 січня 2023',
    location: 'Одесса, вул. Генуезька, 5/2, ТРК "Гагарин Плаза',
    image: EventImage4,
  },
  {
    title: 'Конкурс "Найстильніший одяг"',
    date: '23 грудня 2022',
    location: 'Одесса, вул. Люстдорфська дорога, 55',
    image: EventImage5,
  },
];

const Event = ({ date, image, location, title }: EventProps) => {
  const theme = useTheme();
  const [isEventSaved, setIsEventSaved] = useState(false);
  return (
        <EventWrapper>
            <div className='account-event-top-line'>
                <div className='account-event-user'>
                    <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-event-user-avatar-wrapper'>
                        <SmallKimsLogo height={30} width={30} />
                    </div>
                    <div className='account-post-user'>
                        <span className='account-event-user-name'>Хімчистка KIMS</span>
                        <div style={{ backgroundColor: theme.colors.primaryColor }} className='account-event-verification-wrapper'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M12 6L6.5 11L4 8.72727" stroke="#F7F7F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <IconButton size={30} onClick={() => setIsEventSaved(!isEventSaved)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 16L19 21V2H5V21L12 16Z" fill={isEventSaved ? theme.colors.primaryColor : 'transparent'} stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
            <div className='account-event-content'>
                <div className='account-event-image-wrapper'>
                    <img src={image} />
                </div>
                <div className='account-event-info'>
                    <span className='account-event-title'>{title}</span>
                    <div className='account-event-info-line'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 6.66667H14M4.66667 2V3.33333M11.3333 2V3.33333M4.13333 14H11.8667C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7269 13.7269 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V5.46667C14 4.71993 14 4.34656 13.8547 4.06135C13.7269 3.81046 13.5229 3.60649 13.272 3.47866C12.9868 3.33333 12.6134 3.33333 11.8667 3.33333H4.13333C3.3866 3.33333 3.01323 3.33333 2.72801 3.47866C2.47713 3.60649 2.27315 3.81046 2.14533 4.06135C2 4.34656 2 4.71993 2 5.46667V11.8667C2 12.6134 2 12.9868 2.14533 13.272C2.27315 13.5229 2.47713 13.7269 2.72801 13.8547C3.01323 14 3.38659 14 4.13333 14Z" stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p className='new-p account-event-text'>{date}</p>
                    </div>
                    <div className='account-event-info-line'>
                        <LocationIcon height={16} width={16} className='svg-black svg-fill' />
                        <p className='new-p account-event-text'>{location}</p>
                    </div>
                </div>
            </div>
        </EventWrapper>
  );
};

export default function EventsPage() {
  const { searchValue, onSearchChange } = useSearch();
  const searchedEvents = EventList.filter((event) => event.title.toLowerCase().includes(searchValue.toLowerCase()));
  return (
        <div className="account-events-section">
            <SearchWrapper>
                <SearchInput value={searchValue} onChange={onSearchChange} wrapperStyle={{ flex: '1 0 auto' }} placeholder='Пошук...' />
                <IconButton>
                    <FilterIcon className='svg-black' />
                </IconButton>
            </SearchWrapper>
            <div className="account-events-list">
                {!searchValue ? EventList.map((event, index) => (
                    <Event {...event} key={index} />
                )) : searchedEvents.map((event, index) => (
                    <Event {...event} key={index} />
                ))}
            </div>
        </div>
  );
}